import {
  SHOW_LOADING,
  HIDE_LOADING,
  GET_APP_EMAIL_TEMPLATE_LIST,
  ADD_APP_EMAIL_TEMPLATE,
  UPDATE_APP_EMAIL_TEMPLATE,
  APP_EMAIL_TEMPLATE_LIST,
  DELETE_APP_EMAIL_TEMPLATE,
  SET_ADD_EDIT,
  GET_APP_INSTANCE_EMAIL_TEMPLATE_LIST,
  APP_INSTANCE_EMAIL_TEMPLATE_LIST,
  ADD_APP_INSTANCE_EMAIL_TEMPLATE,
  UPDATE_APP_INSTANCE_EMAIL_TEMPLATE,
  DELETE_APP_INSTANCE_EMAIL_TEMPLATE,
  EMAIL_TEMPLATE_MESSAGE
} from "redux/constants/template";

export const getAppEmailTemplateList = (requestData) => {
  return {
    type: GET_APP_EMAIL_TEMPLATE_LIST,
    payload: requestData,
  };
};

export const templates = (templates)=> {
    return {
        type: APP_EMAIL_TEMPLATE_LIST,
        payload: templates,
      };
}

export const addAddAppEmailTemplate = (data) => {
  return {
    type: ADD_APP_EMAIL_TEMPLATE,
    payload: data,
  };
};

export const updateAppEmailTemplate = (data) => {
  return {
    type: UPDATE_APP_EMAIL_TEMPLATE,
    payload: data,
  };
};

export const deleteAppEmailTemplate = (appEmailTemplate) => {
    return {
      type: DELETE_APP_EMAIL_TEMPLATE,
      payload: appEmailTemplate,
    };
  };

  export const getAppInstanceEmailTemplateList = (requestData) => {
    return {
      type: GET_APP_INSTANCE_EMAIL_TEMPLATE_LIST,
      payload: requestData,
    };
  };
  
  export const instanceTemplates = (templates)=> {
      return {
          type: APP_INSTANCE_EMAIL_TEMPLATE_LIST,
          payload: templates,
        };
  }
  
  export const addAppInstanceEmailTemplate = (data) => {
    return {
      type: ADD_APP_INSTANCE_EMAIL_TEMPLATE,
      payload: data,
    };
  };
  
  export const updateAppInstanceEmailTemplate = (data) => {
    return {
      type: UPDATE_APP_INSTANCE_EMAIL_TEMPLATE,
      payload: data,
    };
  };
  
  export const deleteAppInstanceEmailTemplate = (appEmailTemplate) => {
      return {
        type: DELETE_APP_INSTANCE_EMAIL_TEMPLATE,
        payload: appEmailTemplate,
      };
    };

export const showTemplateMessage= (response) =>{
  return {
    type: EMAIL_TEMPLATE_MESSAGE,
    response,
  };
}

export const setAddEdit = (value) => {
    return {
        type: SET_ADD_EDIT,
        addEditValue: value,
    };
};

export const showLoading = () => {
    return {
      type: SHOW_LOADING,
    };
  };
  
  export const hideLoading = () => {
    return {
      type: HIDE_LOADING,
    };
  };